import { XMATTERS_HELP_URL_ROOT, XMATTERS_HELP_URL } from 'xm-constants/urls';

const getHelpUrl = cshid => `${XMATTERS_HELP_URL}/#cshid=${cshid}`;

export const helpLinks = {
  // ROOT is used for concatonating elsewhere, much like `getHelpUrl` uses it
  // but generally with `/ondemand` or `/integration` prefix already intact:
  ROOT: XMATTERS_HELP_URL_ROOT,
  // DEFAULT is what should load if there are no other relevant help available in a given context:
  DEFAULT: `${XMATTERS_HELP_URL}/xmatters.htm`,

  AddPhoneRecording: getHelpUrl('AddPhoneRecording'),
  AddPlaybook: getHelpUrl('AddPlaybook'),
  AddUsers: getHelpUrl('AddUsers'),
  AlertsReportViews: getHelpUrl('AlertsReportViews'),
  APIExternalOwnership: getHelpUrl('APIExternalOwnership'),
  APIKeyCredentials: getHelpUrl('APIKeyCredentials'),
  AutomationTrigger: getHelpUrl('AutomationTrigger'),
  BasicCompanyDetailsPlace: getHelpUrl('BasicCompanyDetailsPlace'),
  BroadcastGroupDetails: getHelpUrl('BroadcastGroupDetails'),
  ChangeRecord: getHelpUrl('ChangeRecord'),
  CompanyHolidaysList: getHelpUrl('CompanyHolidaysList'),
  CompanyNotificationReportPlace: getHelpUrl('CompanyNotificationReportPlace'),
  ConferenceBridgeManagementPlace: getHelpUrl(
    'ConferenceBridgeManagementPlace',
  ),
  ConferenceBridges: getHelpUrl('ConferenceBridges'),
  ConferencesLearnMore: getHelpUrl('ConferencesLearnMore'),
  ConferencesReportPlace: getHelpUrl('ConferencesReportPlace'),
  ConvertOutbound: getHelpUrl('ConvertOutbound'),
  CopyGroups: getHelpUrl('CopyGroups'),
  CreateGroup: getHelpUrl('CreateGroup'),
  CreateWorkflow: getHelpUrl('CreateWorkflow'),
  CustomAttributes: getHelpUrl('CustomAttributes'),
  CustomFields: getHelpUrl('CustomFields'),
  CustomHolidaysList: getHelpUrl('CustomHolidaysList'),
  CustomUserInfo: getHelpUrl('CustomUserInfo'),
  DashboardPlace: getHelpUrl('DashboardPlace'),
  DataRetention: getHelpUrl('DataRetention'),
  DeviceManagementPlace: getHelpUrl('DeviceManagementPlace'),
  DSTChanges: getHelpUrl('DSTChanges'),
  DeviceNameDetailPlace: getHelpUrl('DeviceNameDetailPlace'),
  DynamicGroups: getHelpUrl('DynamicTeamOverview'),
  DynamicGroupOptions: getHelpUrl('DynamicTeamOptions'),
  DynamicTeams: getHelpUrl('DynamicTeams'),
  DynamicTeamsList: getHelpUrl('DynamicTeamsList'),
  DynamicTeamObservers: getHelpUrl('DynamicTeamObservers'),
  EpicStatusReportPlace: getHelpUrl('EpicStatusReportPlace'),
  EventDetailsReportPlace: getHelpUrl('EventDetailsReportPlace'),
  EventReport: getHelpUrl('EventReport'),
  EventsReportPlace: getHelpUrl('EventsReportPlace'),
  EverbridgeIncidentResponses: getHelpUrl('EverbridgeIncidentResponses'),
  ExternalConferenceBridgeListPlace: getHelpUrl(
    'ExternalConferenceBridgeListPlace',
  ),
  ExternalDataPage: getHelpUrl('ExternallyOwned'),
  ExternalPropertiesListPlace: getHelpUrl('ExternalPropertiesListPlace'),
  FindRecordings: getHelpUrl('FindRecordings'),
  FindStep: getHelpUrl('FindStep'),
  FloodControlPlace: getHelpUrl('FloodControlPlace'),
  FlowActivityPanel: getHelpUrl('FlowActivityPanel'),
  FlowConvertToTrigger: getHelpUrl('FlowConvertToTrigger'),
  FlowDesignerPlace: getHelpUrl('FlowDesignerPlace'),
  FlowMergeStep: getHelpUrl('FlowMergeStep'),
  FlowScriptReference: getHelpUrl('FlowScriptReference'),
  FlowTriggersHTTP: getHelpUrl('FlowTriggersHTTP'),
  GroupOptions: getHelpUrl('GroupOptions'),
  GroupOverviewPlace: getHelpUrl('GroupOverviewPlace'),
  GroupPerformanceReportPlace: getHelpUrl('GroupPerformanceReportPlace'),
  GroupSchedulePlace: getHelpUrl('GroupSchedulePlace'),
  GroupRosterPlace: getHelpUrl('GroupRosterPlace'),
  GroupsPlace: getHelpUrl('GroupsPlace'),
  AlertsReport: getHelpUrl('HistoricalEventsReportPlace'),
  HistoricalOnCallPlace: getHelpUrl('HistoricalOnCallPlace'),
  HomePagePlace: getHelpUrl('HomePagePlace'),
  ImportJobDetailsReportPlace: getHelpUrl('ImportJobDetailsReportPlace'),
  ImportJobHistoryReportPlace: getHelpUrl('ImportJobHistoryReportPlace'),
  ImportWorkflow: getHelpUrl('ImportWorkflow'),
  InboxPlace: getHelpUrl('InboxPlace'),
  IncidentCollaborationSlack: getHelpUrl('IncidentCollaborationSlack'),
  IncidentCollaborationTeams: getHelpUrl('IncidentCollaborationTeams'),
  IncidentCollaborationTeamsMeeting: getHelpUrl(
    'IncidentCollaborationTeamsMeeting',
  ),
  IncidentCollaborationxMConferenceBridge: getHelpUrl(
    'IncidentCollaborationxMConferenceBridge',
  ),
  IncidentCollaborationZoom: getHelpUrl('IncidentCollaborationZoom'),
  IncidentPlaybooks: getHelpUrl('Playbooks'),
  IncidentsList: getHelpUrl('IncidentsList'),
  IncidentsPlace: getHelpUrl('IncidentsPlace'),
  IncidentTypes: getHelpUrl('IncidentTypes'),
  IncidentTaskLists: getHelpUrl('IncidentTaskLists'),
  InitiateIncident: getHelpUrl('InitiateIncident'),
  InitiationTrigger: getHelpUrl('InitiationTrigger'),
  IntegrationDetailsPlace: getHelpUrl('IntegrationDetailsPlace'),
  IntegrationLogPlace: getHelpUrl('IntegrationLogPlace'),
  IntegrationManagerPlace: getHelpUrl('IntegrationManagerPlace'),
  LocationsAndLanguages: getHelpUrl('LanguagesPlace'),
  ManageResponseTranslations: getHelpUrl('ManageResponseTranslations'),
  ManageTextTranslations: getHelpUrl('ManageTextTranslations'),
  MessagingList: getHelpUrl('MessagingList'),
  MobileAppQRCode: getHelpUrl('MobileAppQRCode'),
  NotificationResponses: getHelpUrl('NotificationResponses'),
  OauthCredentialsPlace: getHelpUrl('OauthCredentialsPlace'),
  OnCallGroupDetails: getHelpUrl('OnCallGroupDetails'),
  OutgoingCallerId: getHelpUrl('OutgoingCallerId'),
  PanelListPlace: getHelpUrl('PanelListPlace'),
  // "PanelSectionsPlace" and "MessagingList" cshids both redirect to the same page.
  // For now prodcomms has agreed that both can point to cshid="MessagingList" so that the
  // UI knows they're identical:
  PanelSectionsPlace: getHelpUrl('MessagingList'),
  PasswordPolicyForm: getHelpUrl('PasswordPolicyForm'),
  PhoneRecordingDetailForm: getHelpUrl('PhoneRecordingDetailForm'),
  PhoneRecordingList: getHelpUrl('PhoneRecordingList'),
  PlanOverviewPlace: getHelpUrl('PlanOverviewPlace'),
  PlanUpgradePlace: getHelpUrl('PlanUpgradePlace'),
  PrivilegedDevices: getHelpUrl('PrivilegedDevices'),
  PropertiesListPlace: getHelpUrl('PropertiesListPlace'),
  ReadOnlyDependencies: getHelpUrl('ReadOnlyDependencies'),
  RunAutomations: getHelpUrl('RunAutomations'),
  SAML: getHelpUrl('SAML'),
  SAMLSettings: getHelpUrl('SAMLSettings'),
  ScheduledMessagesPlace: getHelpUrl('ScheduledMessagesPlace'),
  ScriptEditorScriptReferencePlace: getHelpUrl(
    'ScriptEditorScriptReferencePlace',
  ),
  SecuritySettingsPage: getHelpUrl('SecuritySettingsPage'),
  ServiceDependencies: getHelpUrl('ServiceDependencies'),
  Services: getHelpUrl('Services'),
  SharedAutomations: getHelpUrl('SharedAutomations'),
  SignalsReport: getHelpUrl('SignalsReport'),
  SiteDetailPlace: getHelpUrl('SiteDetailPlace'),
  SiteHolidaysList: getHelpUrl('SiteHolidaysList'),
  SitesPlace: getHelpUrl('SitesPlace'),
  SMSBestPractices: getHelpUrl('SMSBestPractices'),
  SubscriptionFormListPlace: getHelpUrl('SubscriptionFormListPlace'),
  SystemApplicationListPlace: getHelpUrl('SystemApplicationListPlace'),
  SystemNotificationReportPlace: getHelpUrl('SystemNotificationReportPlace'),
  TriggerFloodControl: getHelpUrl('TriggerFloodControl'),
  TTSDictionaryPlace: getHelpUrl('TTSDictionaryPlace'),
  UserDetailsPlace: getHelpUrl('UserDetailsPlace'),
  UserDevicesPlace: getHelpUrl('UserDevicesPlace'),
  UserGroups: getHelpUrl('UserGroups'),
  UserPerformanceReportPlace: getHelpUrl('UserPerformanceReportPlace'),
  UserPropertiesPage: getHelpUrl('CustomUserInfo'),
  UserSchedulePlace: getHelpUrl('UserSchedulePlace'),
  UsersPlace: getHelpUrl('UsersPlace'),
  UsersSupervisedPlace: getHelpUrl('UsersSupervisedPlace'),
  UserSubscriptionsPlace: getHelpUrl('UserSubscriptionsPlace'),
  UserSupervisorsPlace: getHelpUrl('UserSupervisorsPlace'),
  UserUpload: getHelpUrl('UserUpload'),
  VoiceRecordingsPlace: getHelpUrl('MessagesVoice'),
  webServiceUserDetailsForm: getHelpUrl('webServiceUserDetailsForm'),
  WhosOnDutyGroupSelectionPlace: getHelpUrl('WhosOnDutyGroupSelectionPlace'),
  WorkflowListPlace: getHelpUrl('WorkflowListPlace'),
  Workflows: getHelpUrl('Workflows'),
  WorkflowsAuditReport: getHelpUrl('WorkflowsAuditReport'),
  WorkflowTemplateGuides: `${XMATTERS_HELP_URL_ROOT}/integrations/all-integrations.htm`,
  XAgentManagerPlace: getHelpUrl('XAgentManagerPlace'),
  XATroubleshooting: getHelpUrl('XATroubleshooting'),
  Xmagent: getHelpUrl('Xmagent'),
};
